export default {
  title: '会员等级特权',
  addLevel: '添加会员等级',
  levelName: '等级名称',
  levelNamePlaceholder: '请输入等级名称',
  addI18n: '添加多语言',
  addTitle: '新增会员等级',
  editTitle: '编辑会员等级',
  deleteConfirm: '删除后不可恢复，确定要删除吗？',
  columns: {
    level: '等级',
    name: '等级名称',
    growth: '所需成长值',
    memberCount: '会员数量',
    sort: '排序',
    status: '状态',
    benefitCount: '会员数量',
  },
  form: {
    baseInfo: '基础信息',
    levelName: '会员等级名称',
    levelNamePlaceholder: '请输入等级名称',
    levelNameRequired: '请输入等级名称',
    namePlaceholder: '请输入等级名称',
    growthValue: '会员成长值',
    growthValuePlaceholder: '请输入成长值',
    growthValueRequired: '请输入成长值',
    birthdayGift: '生日礼包',
    birthdayGiftDesc: '用户生日时，系统自动赠送积分奖励',
    sendPoints: '送积分',
    pointsPlaceholder: '请输入',
    pointsUnit: '积分',
    birthdayPointsRequired: '请输入赠送积分数',
    discountPrivilege: '折扣特权',
    discountPrivilegeDesc: '用户使用积分兑换礼品时可享受折扣',
    pointsExchangeGift: '积分兑换礼品',
    discountPlaceholder: '请输入',
    discountUnit: '折',
    discountRequired: '请输入折扣值',
  },
  i18nEditTitle: '多语言编辑',
  i18nModal: {
    title: '多语言（等级名称）',
    nameSuffix: '等级名称',
  },
};
